import { Shield, AlertTriangle, CheckCircle } from "lucide-react";

export const SpfDkimDmarcTakeaway = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-2xl p-6 sm:p-8 border border-primary/20">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
          <Shield className="w-6 h-6 text-primary" />
        </div>
        <div>
          <h3 className="font-display text-lg font-semibold text-foreground mb-2">
            The Bottom Line
          </h3>
          <p className="text-muted-foreground leading-relaxed">
            <strong className="text-foreground">Without proper authentication, up to 20% of legitimate emails never reach the inbox.</strong> SPF verifies your sending servers, DKIM cryptographically signs your messages, and DMARC tells receivers what to do when checks fail. Together, they form the foundation of email deliverability.
          </p>
          <div className="flex flex-wrap gap-3 mt-4">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-success/10 text-success text-sm">
              <CheckCircle className="w-3.5 h-3.5" />
              All 3 required by Google/Yahoo
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-warning/10 text-warning text-sm">
              <AlertTriangle className="w-3.5 h-3.5" />
              Misconfiguration = spam folder
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
